import { Injectable } from '@angular/core';
import { BoSpinnerService, BoToastrService } from 'src/@core/shared';
import { CreateQuotationRequest, PaginationQuotationRequest } from './quotations.DTO';
import { API } from '../config/api';
import { tap, catchError } from 'rxjs/operators';
//import { HttpClient } from '@angular/common/http';
import { SUCCESS } from 'src/@shared/constants';
import { ErrorResponse, PaginationResponse } from '../config/common';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { Quotation, QuoteListToProcess } from 'src/@core/models/quotations';
import { requestQuery } from 'src/@shared/untils';
import { request } from 'http';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
//import { SignalRService } from '../signalR';

//import { QuotationsSharedService} from './quotationsShared.service';

@Injectable()
export class QuotationsService {
  public objecMenu = new BehaviorSubject('');
  public quoteAllBooked = new Subject<any>();
  

  constructor(private _http: HttpClient,
    private _spinner: BoSpinnerService,
    private _toastr: BoToastrService,
    private authService: AuthService,
  ) {
  }

  public getQuotationAfterConvert() {
    this.objecMenu.next('');
  }

  public create(model: CreateQuotationRequest) {
    return this._http.post(`${API.QUOTATION.CREATE}`, model)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.CREATE_QUOTATION);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      );
  }

  public getQuotationsNeedProcessing(): Observable<QuoteListToProcess[]> {
    if (!this.authService.IsAuthenticate) {
      return;
    }
    this._spinner.show(true);
    return this._http.get < QuoteListToProcess[]>(`${API.QUOTATION.GET_QUOTATION_NEED_PROCESSING}`).pipe(tap(() => this._spinner.hide()));

    //return this._http.get(`${API.QUOTATION.GET_QUOTATION_NEED_PROCESSING}`)
    //  .pipe(
    //    tap(() => {
    //    }),
    //    catchError((err: ErrorResponse) => {
    //      this._toastr.errors(err.error.errors);
    //      throw err;
    //    })
    //  )
  }
  public getQuotations(request: PaginationQuotationRequest, disableSpinner?: boolean): Observable<PaginationResponse<Quotation>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<PaginationResponse<Quotation>>(`${API.QUOTATION.GET_QUOTATION}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public delete(id: string) {
    return this._http.delete(API.QUOTATION.DELETE(id))
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.DELETE_QUOTATION);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      )
  }

  public deleteAfterConvert(id: string) {
    return this._http.delete(API.QUOTATION.DELETE(id))
      .pipe(
        tap(() => {
          // this._toastr.successCode(SUCCESS.DELETE_QUOTATION);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      )
  }

  public calculateSameDayPrice(customerId: string | null, VehicleTypeID: string, milesBetweenTwoPostCode: number) {
    return this._http.get(`${API.QUOTATION.GET_SAMEDAY_PRICING}?customerID=${customerId}&VehicleTypeID=${VehicleTypeID}&milesBetweenTwoPostCode=${milesBetweenTwoPostCode}`)
      .pipe(
        tap(() => {
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      )
  }

  public getQuotationsForCurrentUser(request: PaginationQuotationRequest, disableSpinner?: boolean): Observable<PaginationResponse<Quotation>> {
    if (!disableSpinner) {
      this._spinner.show(true);
    }
    return this._http.get<PaginationResponse<Quotation>>(`${API.QUOTATION.GET_QUOTATION_FOR_CURRENT_USER}?${requestQuery(request)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public getQuotationConvert(id: string) {
    //    //if (!disableSpinner) {
    //    //    this._spinner.show(true);
    //    //}
    return this._http.get<PaginationResponse<Quotation>>(`${API.QUOTATION.GET_QUOTATIONCONVERT(id)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  public getQuotation(id: string) {
    //    //if (!disableSpinner) {
    //    //    this._spinner.show(true);
    //    //}
    return this._http.get<PaginationResponse<Quotation>>(`${API.QUOTATION.GET_SINGLEQUOTATION(id)}`)
      .pipe(tap(() => this._spinner.hide()));
  }

  
}
